import React, { useState, useEffect, useRef } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import photo from "../../../Assets/Images/photo.png";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { IoMdArrowBack } from "react-icons/io";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const UpperHeader = ({ handleToggleEditSideBar, toggleEditSideBar }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    if (toggleEditSideBar) {
      document.body.classList.add("editsidebar");
    } else {
      document.body.classList.remove("editsidebar");
    }

    return () => {
      document.body.classList.remove("editsidebar");
    };
  }, [isSidebarOpen]);

  const { selectedStaff, baseUrl, fetchStaffs, openToast } = useGlobalContext();
  console.log(selectedStaff);
  const [toggleDrop, setToggleDrop] = useState(false);
  const dropdownRef = useRef(null);
  const [status, setStatus] = useState(true);
  const navigate = useNavigate();

  const handledrop = () => {
    setToggleDrop((prev) => !prev);
  };

  async function deleteStaff() {
    try {
      const response = await fetch(`${baseUrl}staff/${selectedStaff?.id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (response.status == 201) {
        openToast("Staff Delete Successfully", "success");
        navigate("/staff-menu");
        fetchStaffs();
      }

      // Success
      const data = await response.json();
      console.log("Staff deleted successfully:", data);
    } catch (error) {
      // Handle network or other unexpected errors
      console.error("Error:", error);
      alert(
        "An error occurred while trying to delete staff. Please try again."
      );
    }
  }

  console.log(status)

  async function updateStaff(){
    try {
   
      const response = await fetch(`${baseUrl}/staff/status/${selectedStaff?.staffDetails?.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body:JSON.stringify({
          status: status
      })
      });

      if (response.status === 200) {
        openToast(" Update Staff Successfully", "success");
        setStatus(!status); // Update local state if API call is successful
      } 
    } catch (error) {
      
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setToggleDrop(false); // Close the dropdown if clicking outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // handle the back arrow button
  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="top-0 z-[1] fixed flex justify-between bg-white shadow-md p-3 border-b w-full">
      <div className="flex items-center gap-2">
        <button onClick={handleBackButtonClick}>
          <ArrowBackIcon />
        </button>
        <button
          onClick={() => {
            handleToggleEditSideBar();
          }}
          className="toggle-btn-side"
        >
          <MenuIcon className="menu-icon" />
          <CloseIcon className="close-icon" />
        </button>

        <img src={photo} className="w-[40px] h-[40px]" />
      </div>
      <div className="flex items-center gap-2">
        <Link
          to="/staff-menu"
          className="flex items-center gap-[6px] go-staff second-btn"
        >
          {" "}
          <IoMdArrowBack className="text-[18px]" /> Go back to staff menu
        </Link>

        <span
        className={`${
          status
            ? "bg-[#effaf4] text-[#2db567]"
            : "bg-[#faeaea] text-[#d9534f]"
        } pt-2 pb-2 pl-6 pr-5 rounded-3xl`}
      >
        {status ? "Active" : "InActive"}
      </span>
        <div className="relative" ref={dropdownRef}>
          <button className="" onClick={handledrop}>
            <MoreVertIcon />
          </button>
          {toggleDrop && (
            <div
              className="right-0 z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 origin-top-right focus:outline-none"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabIndex="-1"
            >
              <div className="py-1" role="none">
                <button
                  className="block px-4 py-2 w-full text-gray-700 text-left text-sm"
                  role="menuitem"
                  tabIndex="-1"
                  id="menu-item-0"
                  onClick={updateStaff}
                >
                  Mark Staff {status ? "Inactive" : "Active"}
                </button>
                <Link
                  to="#"
                  className="block px-4 py-2 text-red-700 text-sm"
                  role="menuitem"
                  tabIndex="-1"
                  onClick={deleteStaff}
                  id="menu-item-1"
                >
                  Delete Staff
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpperHeader;
